import React, { useRef,useState } from "react";
import { FaArrowLeft } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import Header from "./partial/Header";
import Sidebar from "./partial/Sidebar";
import toast, { Toaster } from "react-hot-toast";
import { useAddDestinationMutation } from "../../redux/API/DestinationApi";

const AddDestination = () => {
  const [newClass, setNewClass] = useState("");
  const [newSidebarClass, setNewSidebarClass] = useState("");
  const [showPass, setShowPass] = useState(false);
  const [destinationData, setDestinationData] = useState({
    name: "",
    description: "",
  });
  const [image, setImage] = useState([]);
  const fileInputRef = useRef(null);
  const [showError, setShowError] = useState({
    name: false,
    description: false,
    image: false,
  });
  const [postData] = useAddDestinationMutation();
  const navigate = useNavigate();

  const handleImage = (e) => {
    const file = e.target.files[0];
    const sizeLimit = 2 * 1024 * 1024;
  
    const allowedTypes = ["image/jpeg", "image/png", "image/webp"];
    const allowedExtensions = ["jpg", "jpeg", "png", "webp"];
  
    if (!file) return;
  
    const ext = file.name.split(".").pop().toLowerCase();
    const isValidType = allowedTypes.includes(file.type);
    const isValidExtension = allowedExtensions.includes(ext);
  
    const resetInput = () => {
      setImage(null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
        // Force re-render to allow re-upload of same file
        e.target.type = '';
        e.target.type = 'file';
      }
    };
  
    if (!isValidType || !isValidExtension) {
      toast.error("Invalid file format. Only JPG, JPEG, PNG, WEBP are allowed.");
      resetInput();
      return;
    }
  
    if (file.size > sizeLimit) {
      toast.error("File size should be less than 2MB");
      resetInput();
      return;
    }
  
    const img = new Image();
    img.src = URL.createObjectURL(file);
  
    img.onload = () => {
      if (img.width === 1500 && img.height === 400) {
        setImage(file);
      } else {
        toast.error("Image dimensions should be 1500*400");
        resetInput();
      }
      URL.revokeObjectURL(img.src);
    };
  
    img.onerror = () => {
      toast.error("Invalid image file.");
      resetInput();
      URL.revokeObjectURL(img.src);
    };
  };
  

  // const handleImage = (e) => {
  //   const files = Array.from(e.target.files);
  //   if (files.length > 0) {
  //     const newImages = files.map((file) => ({
  //       file,
  //     }));
  //     setImage(newImages);
  //   }
  // };

  // Handle Form Submit
  const handleCreateDestination = (e) => {
    e.preventDefault();
  
    const checkFields = {
      name: destinationData.name === "",
      description: destinationData.description === "",
      image: image.length === 0,
    };
    setShowError(checkFields);
  
    const hasError = Object.values(checkFields).some((error) => error);
    if (hasError) return;
  
    const formData = new FormData();
    if (image) {
      formData.append("image", image);
    }
    formData.append("name", destinationData.name);
    formData.append("description", destinationData.description);
  
    postData(formData)
      .then((res) => {
        if (res?.data?.success) {
          toast.success(res?.data?.message || "Destination created successfully!", {
            duration: 3000,
          });
          setTimeout(() => {
            navigate("/admin/destinations");
          }, 1000);
          setDestinationData({
            name: "",
            description: "",
          });
          setImage([]);
        } else {
          // Handle backend message from error (like slug exists)
          toast.error(res?.error?.data?.message || "Something went wrong, Please try again later.");
        }
      })
      .catch((err) => {
        console.error(err);
        toast.error("Something went wrong. Please try again.");
      });
  };
  
  const handleToggle = () => {
    if (newClass === "") {
      setNewClass("main-active");
    } else {
      setNewClass("");
    }
    if (newSidebarClass === "") {
      setNewSidebarClass("closed");
    } else {
      setNewSidebarClass("");
    }
  };

  return (
    <>
      <Toaster position="top-right" />
      <Sidebar newSidebarClass={newSidebarClass} />
      <div className={`main-context ${newClass}`}>
        <Header handleToggle={handleToggle} setShowPass={setShowPass} />
        <div className="admin-dashboard p-4">
          <div aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active" aria-current="page">
                Add Destination
              </li>
            </ol>
          </div>
          <div className="d-flex justify-content-end pe-2 mb-3">
            <Link
              to="/admin/destinations"
              className="btn btn-primary rounded-2"
            >
              Back <FaArrowLeft />
            </Link>
          </div>
          <div className="container card p-4">
            <form className="row gy-3" onSubmit={handleCreateDestination}>
              <div className="col-lg-6">
                <label htmlFor="name">
                  Destination Name <sup className="text-danger fs-6">*</sup>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  placeholder="Enter Destination Name"
                  value={destinationData.name}
                  onChange={(e) =>
                    setDestinationData({
                      ...destinationData,
                      name: e.target.value,
                    })
                  }
                />
                {showError.name && (
                  <p className="text-danger wel mt-1 mb-0">
                    Please Provide Destination Name
                  </p>
                )}
              </div>
              <div className="col-lg-6">
                <label htmlFor="description">
                  Description <sup className="text-danger fs-6">*</sup>
                </label>
                <textarea
                  className="form-control"
                  id="description"
                  name="description"
                  placeholder="Enter Description"
                  value={destinationData.description}
                  onChange={(e) =>
                    setDestinationData({
                      ...destinationData,
                      description: e.target.value,
                    })
                  }
                />
                {showError.description && (
                  <p className="text-danger wel mt-1 mb-0">
                    Please Provide Description
                  </p>
                )}
              </div>
              <div className="col-lg-6">
                <label htmlFor="image">
                  Image <sup className="text-danger fs-6">*</sup>
                </label>
                <input
                  type="file"
                  className="form-control"
                  id="image"
                  name="image"
                  onChange={handleImage}
                  ref={fileInputRef}
                />
                {showError.image && (
                  <p className="text-danger wel mt-1 mb-0">
                    Please Upload an Image
                  </p>
                )}
              </div>
              <div className="col-lg-6 pt-4">
                <button
                  className="btn btn-primary px-4 rounded-2"
                  type="submit"
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* {showPass && <ChangePassword setShowPass={setShowPass} />} */}
    </>
  );
};

export default AddDestination;
